export default __webpack_public_path__ + "static/media/collectionscarousel.805c2432.svg";